import { render, staticRenderFns } from "./CustomerWorkflow.vue?vue&type=template&id=240d8a86&scoped=true&"
import script from "./CustomerWorkflow.vue?vue&type=script&lang=ts&"
export * from "./CustomerWorkflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d8a86",
  null
  
)

export default component.exports